export function SectionHeading({ eyebrow, title, description, align = "left" }) {
  const centered = align === "center";
  return (
    <div className={centered ? "mx-auto max-w-3xl text-center" : "max-w-3xl"} data-testid={`${eyebrow.toLowerCase().replaceAll(" ", "-")}-section-heading`}>
      <p className="text-sm font-semibold uppercase tracking-[0.3em] text-primary">{eyebrow}</p>
      <h2 className="mt-4 text-3xl font-semibold tracking-tight sm:text-4xl">{title}</h2>
      {description ? <p className="mt-5 text-base leading-relaxed text-muted-foreground md:text-lg">{description}</p> : null}
    </div>
  );
}
